export default "__VITE_ASSET__9437efa5__"